<!--
 * @Descripttion: 数据大屏组件
 * @Author: zenghua.wang
 * @Date: 2021-12-13 17:30:25
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-14 11:20:24
-->
 <template>
  <section
    class="screen-canvas"
    ref="screenCanvas"
    v-if="loading"
  >
    <div
      class="screen-container"
      :style="styleBackground"
    >
      <div
        v-for="(item, index) in data.list"
        :key="index"
        :style="styleWidget(item)"
      >
        <component
          :is="`drag-${item.type}`"
          :key="index"
          :id="item.prop"
          :apiId="item.apiId"
          :width="item.width"
          :height="item.height"
          :option="item.option"
          :animation="true"
          :disabled="true"
        >
          <template
            v-if="item.type==='slot'"
            :slot="item.option.slotName"
            slot-scope="scope"
          >
            <slot
              :name="item.option.slotName"
              v-bind="scope"
            ></slot>
          </template>
        </component>
      </div>
    </div>
    <div
      class="
              screen-error"
      v-if="showError"
    >ERROR：{{errors}}
    </div>
  </section>
</template>
<script>
/** 引入功能组件、属性组件*/
import '@/dragComponents/index.js'
import { isEmpty, setPx, fixChromeZoom } from '@/dragComponents/utils'
import { FDFS_WEB_SERVER_URL } from '@/dragComponents/model/default.js'

export default {
  name: 'vue-data-screen',
  components: {},
  provide() {
    return {
      category: 'screen',
      device: 'desktop'
    }
  },
  props: {
    // 大屏模型id 必须
    screenId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      showError: false,
      errors: '',
      data: {},
      wscale: 1,
      hscale: 1
    }
  },
  computed: {
    styleBackground() {
      let style = `width:${setPx(this.data.screenWidth)};
      height:${setPx(this.data.screenHeight)};
      background-image:url('${FDFS_WEB_SERVER_URL + this.data.backgroundImage}');
      background-position:center center;
      background-size:100% 100%;
      background-color:${this.data.backgroundColor};
      transform: scale(${this.wscale}, ${this.hscale})`
      return style
    },
    styleWidget() {
      return (widget) => {
        return {
          position: 'absolute',
          left: setPx(widget.left),
          top: setPx(widget.top),
          zIndex: widget.index
        }
      }
    }
  },
  watch: {
    loading(val) {
      if (val) {
        this.$nextTick(() => {
          fixChromeZoom(this.$refs.screenCanvas)
          this.init()
        })
      }
    }
  },
  methods: {
    loadData() {
      let id = this.$route.query.screenId
        ? this.$route.query.screenId
        : this.screenId
      if (isEmpty(id)) return
      this.$http
        .get(`/data-report/model/${id}`)
        .then((res) => {
          if (res.code === 200) {
            this.data = res.data.modelJsonMap
          }
        })
        .catch((err) => {
          this.errors = err.msg
          this.showError = true
        })
        .finally(() => {
          this.loading = true
        })
    },
    init() {
      const refreshScale = () => {
        let docWidth = document.documentElement.clientWidth
        let docHeight = document.documentElement.clientHeight
        let designWidth = this.data.screenWidth || 1920
        let designHeight = this.data.screenHeight || 1080
        this.wscale = docWidth / designWidth
        this.hscale = docHeight / designHeight

        // 应对浏览器全屏切换前后窗口因短暂滚动条问题出现未占满情况
        setTimeout(() => {
          let lateWidth = document.documentElement.clientWidth
          let lateHeight = document.documentElement.clientHeight
          if (lateWidth === docWidth) return
          this.wscale = lateWidth / designWidth
          this.hscale = lateHeight / designHeight
        }, 0)
      }

      refreshScale()

      window.addEventListener(
        'pageshow',
        (e) => {
          if (e.persisted) {
            // 浏览器后退的时候重新计算
            refreshScale()
          }
        },
        false
      )

      window.addEventListener('resize', refreshScale, false)
    }
  },
  created() {
    this.loadData()
  }
}
</script>
<style lang='scss'>
.screen {
  &-canvas {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: #fff;
  }

  &-container {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }

  &-error {
    position: absolute;
    left: 50%;
    top: 40%;
    z-index: 11;
    width: 400px;
    margin-left: -200px;
    text-align: center;
  }
}
</style>
